import { IRequestBase } from '../request-base.model';
import { IResponseBase } from '../response-base.model';

export class ContactRequest extends IRequestBase {

  constructor(email?: string) {
    super();
    this.To = email;
  }

  public Subject: string;
  public From: string;
  public To: string;
  public HtmlContent: string;
}

export class ContactResponse extends IResponseBase {
  public IsSuccess: boolean;
}
